export function includesWhatsappString(conversation_type){
  const conversationTypeLowerCase = conversation_type.toLowerCase();
  return conversationTypeLowerCase.includes('whatsapp');
}